import { Card, CardHeader, Image, makeStyles, Text, Title3 } from "@fluentui/react-components";
import IPageFeature, { IFeature } from "../../../models/page/pageComponents/IPageFeature";

const useStyles = makeStyles({
    cardsContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
    },
    cardCol: {
        maxWidth: "30%", // Controls the width of the card
        width: "100%",
        margin: "10px",
        
        "@media (max-width: 768px)": {
            maxWidth: "100%",
        },
    },
    card: {
        display: "flex",
        flexDirection: "column",
        height: "100%", // Ensure it fills the column
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        padding: "20px",
    },
    title: {
        padding: "10px 20px",
        marginTop: "1rem",
    },
    description: {
        padding: "10px 20px",
        color: "#869ab8",
    }
});

const CardItem = (props: { feature: IFeature }) => {
    const { feature } = props;
    const styles = useStyles();

    const title = <Title3 className={styles.title} align="center">{feature.title}</Title3>,
        description = <Text as="p" size={400} className={styles.description}>{feature.description}</Text>;

    return (
        <Card className={styles.card}>
            <CardHeader header={title} description={description} />
        </Card>
    );
};

export default function FeaturesLayout1(props: IPageFeature) {
    const styles = useStyles();

    return (
        <div className={styles.cardsContainer}>
            {
                props.features.map((feature, index) => (
                    <div className={styles.cardCol} key={index}>
                        <CardItem feature={feature} />
                    </div>
                ))
            }
        </div>
    );
}